import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiurl } from "../config/config";
import { io as socketIOClient } from "socket.io-client";
import { BiCheckCircle, BiXCircle } from "react-icons/bi";
import Layout, { Container } from "../components/layout";
import { getCookie } from "../config/webStorage";
import { useUser } from "../config/userProvider";

const socket = socketIOClient(apiurl, {
  transports: ["websocket"],
  reconnection: true,
});

const LoginApprovalManagement = () => {

  const {userData} = useUser();
  let token = getCookie("swtoken")
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState({});
  const [message, setMessage] = useState("");

  // Fetch requests
  const fetchRequests = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${apiurl}/api/user/pending-logins`);
      setRequests(data.requests || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchRequests();

  //   socket.on("LOGIN_REQUEST", fetchRequests);

  //   socket.on("LOGIN_APPROVED", ({ requestObjId }) => {
  //     setRequests((prev) => prev.filter((r) => r._id !== requestObjId));
  //     setMessage("Login request approved successfully.");
  //   });

  //   socket.on("LOGIN_REJECTED", ({ requestObjId }) => {
  //     setRequests((prev) => prev.filter((r) => r._id !== requestObjId));
  //     setMessage("Login request rejected.");
  //   });

  //   return () => {
  //     socket.off("LOGIN_REQUEST");
  //     socket.off("LOGIN_APPROVED");
  //     socket.off("LOGIN_REJECTED");
  //   };
  // }, []);

  // Approve / Reject handler


  const socket = socketIOClient(apiurl, {
  transports: ["websocket"],
  reconnection: true,
});

useEffect(() => {
  const adminId = userData.userData; 
  // const adminId = getCookie("userId"); // or from auth state

  

  if (adminId) {
    socket.emit("JOIN_USER", adminId); // 🔥 REQUIRED
  }

  fetchRequests();

  socket.on("LOGIN_REQUEST", () => {
    fetchRequests(); // 🔥 AUTO UPDATE
  });

  socket.on("LOGIN_APPROVED", ({ requestObjId }) => {
    setRequests((prev) => prev.filter((r) => r._id !== requestObjId));
  });

  socket.on("LOGIN_REJECTED", ({ requestObjId }) => {
    setRequests((prev) => prev.filter((r) => r._id !== requestObjId));
  });

  return () => {
    socket.off("LOGIN_REQUEST");
    socket.off("LOGIN_APPROVED");
    socket.off("LOGIN_REJECTED");
  };
}, []);



  const handleAction = async (requestObjId, action) => {
  try {
    setActionLoading((prev) => ({ ...prev, [requestObjId]: true }));

    const { data } = await axios.post(
      `${apiurl}/api/user/${action}`,
      { requestObjId }, // 👈 BODY
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token, // or `Bearer ${token}` if backend expects it
        },
      }
    );

    if (data.success) {
      setRequests((prev) => prev.filter((r) => r._id !== requestObjId));
      setMessage(
        `Request ${action.includes("approve") ? "approved" : "rejected"} successfully`
      );
    }
  } catch (err) {
    console.error(err);
    setMessage("Something went wrong.");
  } finally {
    setActionLoading((prev) => ({ ...prev, [requestObjId]: false }));
    setTimeout(() => setMessage(""), 3000);
  }
};


  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="bg-gray-50 p-6 rounded-2xl shadow-lg border">
          <h2 className="text-2xl font-semibold mb-6">
            Pending Login Approvals
          </h2>

          {message && (
            <p className="text-sm text-blue-600 mb-4">{message}</p>
          )}

          {loading && <p className="text-gray-500">Loading...</p>}

          {!loading && requests.length === 0 && (
            <p className="text-gray-500">No pending requests</p>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {requests.map((req) => (
              <div
                key={req._id}
                className="bg-white p-4 rounded-xl shadow-md hover:shadow-xl transition"
              >
                <div className="flex justify-between">
                  <div>
                    <p className="font-semibold text-lg">
                      {req.firstName} {req.lastName}
                    </p>
                    <p className="text-sm text-gray-500">{req.loginId}</p>
                    <p className="text-xs text-gray-400 mt-1">
                      IP: {req.ipAddress}
                    </p>
                  </div>

                  <span className="text-xs px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full">
                    Pending
                  </span>
                </div>

                <div className="flex gap-2 mt-4">
                  <button
                    onClick={() => handleAction(req._id, "approve-login")}
                    disabled={actionLoading[req._id]}
                    className="flex-1 bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-md flex items-center justify-center gap-2"
                  >
                    <BiCheckCircle />
                    Approve
                  </button>

                  <button
                    onClick={() => handleAction(req._id, "reject-login")}
                    disabled={actionLoading[req._id]}
                    className="flex-1 bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-md flex items-center justify-center gap-2"
                  >
                    <BiXCircle />
                    Reject
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default LoginApprovalManagement;